import React from "react";
import PpcFarmTargetLedgerClient from "../../components/ppc-farm/PpcFarmTargetLedgerClient";

const PpcFarmTargetLedgerPage: React.FC = () => {
  return <PpcFarmTargetLedgerClient />;
};

export default PpcFarmTargetLedgerPage;
